// extracted by mini-css-extract-plugin
export default {"root":"BZo9yLwDkjDzIyw4DSot"};